import CommentsAndLikes from './post-comments-and-likes'

export default CommentsAndLikes
